const ITEMS = [
    "Employer of Record",
    "International Employment",
    "Workforce Administration",
    "Legal & Tax Services",
    "Employee Onboarding",
    "United States",
    "Canada",
];

function Row({ ariaHidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-navy/60">
                        {item}
                    </span>
                    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                        <path d="M5 0 10 5 5 10 0 5Z" fill="#C8A96B" />
                    </svg>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-b border-navy/10 bg-white py-5"
        >
            <div className="animate-marquee flex w-max">
                <Row />
                <Row ariaHidden />
            </div>
        </div>
    );
}
